/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Pick_Continue_ActionInputs */

const en_onboarding_v1_pick_continue_action = /** @type {(inputs: Onboarding_V1_Pick_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const de_onboarding_v1_pick_continue_action = /** @type {(inputs: Onboarding_V1_Pick_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

const pt_br2_onboarding_v1_pick_continue_action = /** @type {(inputs: Onboarding_V1_Pick_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const tr_onboarding_v1_pick_continue_action = /** @type {(inputs: Onboarding_V1_Pick_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devam et`)
};

const zh_cn2_onboarding_v1_pick_continue_action = /** @type {(inputs: Onboarding_V1_Pick_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续`)
};

const zh_hk2_onboarding_v1_pick_continue_action = /** @type {(inputs: Onboarding_V1_Pick_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繼續`)
};

const ko_kr2_onboarding_v1_pick_continue_action = /** @type {(inputs: Onboarding_V1_Pick_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속`)
};

const ru_ru2_onboarding_v1_pick_continue_action = /** @type {(inputs: Onboarding_V1_Pick_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить`)
};

const es_419_onboarding_v1_pick_continue_action = /** @type {(inputs: Onboarding_V1_Pick_Continue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Onboarding_V1_Pick_Continue_ActionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_pick_continue_action = /** @type {((inputs?: Onboarding_V1_Pick_Continue_ActionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Pick_Continue_ActionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_pick_continue_action(inputs)
	if (locale === "de") return de_onboarding_v1_pick_continue_action(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_pick_continue_action(inputs)
	if (locale === "tr") return tr_onboarding_v1_pick_continue_action(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_pick_continue_action(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_pick_continue_action(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_pick_continue_action(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_pick_continue_action(inputs)
	return es_419_onboarding_v1_pick_continue_action(inputs)
});